import React, { useCallback, useEffect, useReducer } from "react";

import TransactionFilter from "./partials/TransactionFilter";
import TransactionTable from "./partials/TransactionTable";
import { useCookies } from "react-cookie";
import { calculatePage } from "../../../helper/helper";
import { getSepayTransactionList } from "../../../controller/api/sepayTransaction";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    status: '',
    phone: '',
    content: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return { ...state }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    const response = await getSepayTransactionList(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      status: state.filter.status,
      phone: state.filter.phone,
      content: state.filter.content,
    }, state.filter.page)

    if (response) {
      dispatch({
        type: 'UPDATE_DATA',
        payload: {
          list: response.data,
          total: response.total,
          totalPage: calculatePage(response.total)
        }
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page, state.filter.status, state.filter.phone, state.filter.content])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = "Lịch sử webhook SePay"
  }, []);

  return (
    <Context.Provider value={{ state, dispatch }}>
      <TransactionFilter />
      <br />
      <TransactionTable />
    </Context.Provider>
  );
};
